import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

import Icon from '../Icon';

export const WrapperCheckbox = styled.div`
  align-items: center;
  display: inline-flex;
  position: relative;
`;

export const WrapperCheckboxReverse = WrapperCheckbox.extend`
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  `};
`;

export const StyledCheckable = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.light};
  border: 1px solid ${props => props.theme.colors.grayLight};
  display: flex;
  flex-shrink: 0;
  height: ${rem('24px')};
  justify-content: center;
  width: ${rem('24px')};
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('18px')};
    width: ${rem('18px')};
  `};
`;

export const StyledCheckableReverse = StyledCheckable.extend`
  margin: ${rem('13px')} 0 0 0;
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 0 ${rem('20px')};
  `};
`;

export const StyledIcon = styled(Icon)`
  display: none;
  height: ${rem('11px')};
  position: absolute;
  width: ${rem('11px')};
  ${mediaqueries.greaterThan('mobile')`
    height: ${rem('9px')};
    width: ${rem('9px')};
  `};
`;

export const StyledCheckbox = styled.input.attrs({
  type: 'checkbox'
})`
  cursor: pointer;
  left: 0;
  height: 100%;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
  :hover ~  {
    ${StyledCheckable}, ${StyledCheckableReverse} {
      background-color: ${props => props.theme.colors.gray};
    }
  }
  :checked ~  {
    ${StyledCheckable}, ${StyledCheckableReverse},
      :hover ~ ${StyledCheckable},
      :hover ~ ${StyledCheckableReverse} {
      background-color: ${props => props.theme.colors.secondary};
    }
    ${StyledCheckable}, ${StyledCheckableReverse} {
      ${StyledIcon} {
        display: block;
      }
    }
  }
`;
